import { Link } from "components/Link"
import React from "react"
import type {
  GeneralBynderAsset,
  PromoTile as PromoTileType,
  ReducedImage,
} from "types/cms"
import Image from "next/image"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"

import { imageContainer } from "./PromoTile.css"

type Props = CMSPageProps & PromoTileType

export const PromoTile: React.FC<Props> = ({
  id,
  cta,
  slug,
  image,
  blurb,
  trackingModule,
}) => {
  if (!cta) return null

  const src =
    (image as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails?.["OTF BETA"] ??
    (image as ReducedImage)?.src ??
    "/images/placeholders/800x800.svg"

  const title = (image as ReducedImage)?.filename ?? "image.jpg"

  return (
    <div key={slug}>
      <Link
        id={id}
        href={slug}
        onClick={() =>
          cmsPageClick({
            ...trackingModule,
            moduleContentUrl: slug,
          })
        }
      >
        <div className={imageContainer}>
          <Image
            src={src}
            alt={blurb}
            title={title}
            fill
            sizes="100vw"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
      </Link>
    </div>
  )
}
